<template>
  <div class="trop-location-detail-print">
    <h2 class="title-bunner-container">
      <img class="title-bunner" src="../assets/bunner/map.png" alt="旅の地図">
    </h2>
    <div class="container">
      <div class="row">
        <print-button></print-button>
      </div>
    </div>
    <location-info v-if="data.data" :data="data"></location-info>
    <div class="loading" v-else>Loading....</div>
    <button @click="close" class="close-button btn btn-link text-dark">
      <img src="../assets/arrow_right.png" alt="矢印">印刷ページを閉じる
    </button>
  </div>
</template>

<script>
import WpClient from "../wpClient.js";
import LocationInfo from "@/components/LocationInfo";
import PrintButton from "@/components/PrintButton";

export default {
  components: {
    LocationInfo,
    PrintButton
  },
  props: {
    slug: String
  },
  data: function() {
    return {
      data: {}
    };
  },
  async mounted() {
    this.data = (await WpClient.getLocation(this.slug))[0];
  },
  methods: {
    close() {
      window.close();
    }
  },
  computed: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.back-button {
  display: none;
}

.trop-location-detail-print {
  .map-container {
    height: 300px;
    .map {
      height: 290px;
      @media print {
        width: 950px;
      }
    }
    /* // 中デバイス（タブレット, 768px 以上） */
    @media (min-width: 768px) {
      height: 400px;
      .map {
        height: 390px;
      }
    }
    @media print {
      width: 950px;
      img {
        max-width: none !important;
      }
    }
  }
}
</style>

<style scoped lang="scss">
.datalist {
  margin: 0;
  padding: 8px 0;
  border-bottom: rgb(238, 238, 238) 2px solid;
}
.datalist:first-child {
  border-top: rgb(238, 238, 238) 2px solid;
}

.right-arrow {
  margin-right: 1rem;
  height: 2rem;
  margin-bottom: 3px;
}

img.main_image {
  object-fit: cover;
  max-width: 85%;
  max-height: 50vh;
}

.my-images {
  img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
}

.line {
  white-space: pre-line;
}
.loading {
  height: 200vh;
}

.close-button {
  @media print {
    display: none;
  }
  img {
    margin-right: 1rem;
    height: 2rem;
    margin-bottom: 3px;
  }
}
</style>
